'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var handshake = require('pull-handshake');

var deferred = require('pull-defer');

var State =
/*#__PURE__*/
function () {
  function State(localId, remoteId, timeout, callback) {
    _classCallCheck(this, State);

    if (typeof timeout === 'function') {
      callback = timeout;
      timeout = undefined;
    }

    this.setup();
    this.id.local = localId; // TODO use remoteId to verify PeersIdentity

    this.id.remote = remoteId;
    this.key.local = localId.privKey;
    this.timeout = timeout || 60 * 1000;

    callback = callback || function () {};

    this.secure = deferred.duplex();
    this.stream = handshake({
      timeout: this.timeout
    }, callback);
    this.shake = this.stream.handshake;
    delete this.stream.handshake;
  }

  _createClass(State, [{
    key: "setup",
    value: function setup() {
      this.id = {
        local: null,
        remote: null
      };
      this.key = {
        local: null,
        remote: null
      };
      this.shake = null;
      this.cleanSecrets();
    } // remove all data from the handshake that is not needed anymore

  }, {
    key: "cleanSecrets",
    value: function cleanSecrets() {
      this.shared = {};
      this.ephemeralKey = {
        local: null,
        remote: null
      };
      this.proposal = {
        in: null,
        out: null
      };
      this.proposalEncoded = {
        in: null,
        out: null
      };
      this.protocols = {
        local: null,
        remote: null
      };
      this.exchange = {
        in: null,
        out: null
      };
    }
  }]);

  return State;
}();

module.exports = State;